import api from "../utils/api";
import { isGuid } from "../utils/string";
import { LOGOUT } from "./types";

/**
 * GET one or list
 * - list: GET /payroll/periods
 * - one:  GET /payroll/periods/i/:uuid
 */
export const get = (uuid = null) => async (dispatch) => {
  try {
    const res = await api.get(`/payroll/periods/${isGuid(uuid) ? ("i/" + uuid) : ""}`);
    return isGuid(uuid) ? res.data : res.data?.items;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

/**
 * SEARCH (if your router exposes /p/.. like other modules)
 * GET /payroll/periods/p/:page/s/:size/o/:order/:direction/:search?
 */
export const search = ({
  search = "",
  page = 0,
  size = 25,
  order = "startsOn",
  direction = "DESC",
} = {}) => async (dispatch) => {
  try {
    const term = (search == null || String(search).trim() === "") ? "*" : String(search).trim();
    const enc = encodeURIComponent(term);
    const url = `/payroll/periods/p/${Number(page)}/s/${Number(size)}/o/${order}/${direction}/${enc}`;
    const res = await api.get(url);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

/**
 * SAVE (createOrUpdate)
 * POST /payroll/periods
 */
export const save = (payload = {}) => async (dispatch) => {
  try {
    const res = await api.post(`/payroll/periods`, payload);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};

/**
 * DESTROY
 * DELETE /payroll/periods/i/:uuid
 */
export const destroy = (uuid = null) => async (dispatch) => {
  try {
    if (!isGuid(uuid)) return;
    const res = await api.delete(`/payroll/periods/i/${uuid}`);
    return res.data;
  } catch (err) {
    dispatch({ type: LOGOUT });
  }
};
